import PermissionsService from '@service/PermissionsService';
import * as Oidc from 'oidc-client';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IAuthenticationProps, IConnectedComponent } from 'reducers';
import { Settings } from '../Settings';

export class LoginComponent extends React.Component<IConnectedComponent & IAuthenticationProps & RouteComponentProps<any>, any> {
  componentWillMount() {
    const manager = new Oidc.UserManager(Settings);

    if (this.props.location.hash) {
      manager.signinRedirectCallback().then((u) => this.props.login(u));
    } else {
      manager.signinRedirect();
    }
  }
  render() {
    return null;
  }
}
export default withRouter(connect(undefined, mapDispatchToProps)(LoginComponent) as any);

function mapDispatchToProps(dispatch: any, ownProps: any) {
  return {
    async login(user: any) {
      const userPermissions = await PermissionsService.getUserPermissions(user);
      dispatch({ type: 'USER_LOGIN', loggedInUser: user, userPermissions });
      if (userPermissions == null || userPermissions.permissions == null || userPermissions.permissions.length === 0) {
        ownProps.history.push('/forbidden');
      } else {
        ownProps.history.push('/requests');
      }
    },
  };
}
